export default __webpack_public_path__ + "static/media/20d1f1a68a27eee4611acc4bf5b4e2821598729890509.1fbefda2.webp";